import builder from '../builder';
import AlertTriangle from '../../streamline-icons/light/alert-triangle.svg';

export default builder('IconAlertTriangleLight', AlertTriangle);
